export const HIGHEST_COLOR = "#27B3AD"
export const LOWEST_COLOR = "#F1875A"
